import GenericTableResponse from "@/models/api/GenericTableResponse";
import { COST_DOCUMENT_STATUSES } from "@/static/costDocumentStatuses";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class CostDocumentListItem {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  currency!: string;
  @IsOptional()
  @IsString()
  @Expose()
  description!: string | null;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  issuePlace!: string;
  @IsString()
  @Expose()
  issueDate!: string;
  @IsString()
  @Expose()
  saleDate!: string;
  @IsString()
  @Expose()
  receiptDate!: string;
  @IsNumber()
  @Expose()
  net!: number;
  @IsNumber()
  @Expose()
  netInCurrency!: number;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsOptional()
  @IsString()
  @Expose()
  formOfPaymentName!: string | null;
  @IsBoolean()
  @Expose()
  isPaired!: boolean;
  @IsBoolean()
  @Expose()
  isEditingLocked!: boolean;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsBoolean()
  @Expose()
  hasCorrection!: boolean;
  @IsEnum(COST_DOCUMENT_STATUSES)
  @Expose()
  status!: COST_DOCUMENT_STATUSES;
}

export class CostDocumentListResponse extends GenericTableResponse<CostDocumentListItem> {
  @Type(() => CostDocumentListItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<CostDocumentListItem>;
}
